import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label
} from "reactstrap"
import { Link } from "react-router-dom"
import axios from "axios"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader"
import notDeviceFound from "../../assets/images/flags/noDeviceFound.webp"
import { useNavigate } from "react-router-dom"

const h5Style = {
  fontWeight: "bolder",
}

const spanTextStyle = {
  fontSize: "16px",
}

// Priority: RECHARGE > ACTIVE > STANDBY > ERROR. Returns null if no state available.
const computeSystemState = (br1, br2) => {
  const order = ["RECHARGE", "ACTIVE", "STANDBY", "ERROR"]
  for (const s of order) {
    if (br1 === s || br2 === s) return s
  }
  return br1 || br2 || null
}

const stateLabel = (device) => {
  const sys = computeSystemState(device.BR1_STATUS, device.BR2_STATUS)
  if (!sys) return { text: "N/A", colorClass: "text-muted" }
  if (device.isOffline) {
    const suffix = sys.charAt(0) + sys.slice(1).toLowerCase() // Recharge, Active, Standby, Error
    return { text: `OFFLINE-${suffix}`, colorClass: "text-danger" }
  }
  const colorMap = {
    ACTIVE: "text-success",
    RECHARGE: "text-warning",
    STANDBY: "text-info",
    ERROR: "text-danger",
  }
  return { text: sys, colorClass: colorMap[sys] || "text-muted" }
}

export default function CompanyDevices() {
  const navigate = useNavigate()
  let baseUrl = ""
  switch (process.env.REACT_APP_STATUS) {
    case "DEV":
      baseUrl = process.env.REACT_APP_DEV_URL
      break
    case "STAGE":
      baseUrl = process.env.REACT_APP_STAGE_URL
      break
    case "PROD":
      baseUrl = process.env.REACT_APP_PROD_URL
      break
  }

  const [devices, setDevices] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [company, setCompany] = useState([])
  const [loading, setLoading] = useState(true)

  const [companyID, setCompanyID] = useState()

  const [userRole, setUserRole] = useState("")
  const [userId, setUserId] = useState("")
  const [companyId, setCompanyId] = useState("")

  // Sub-user Invite State
  const [selectedDevices, setSelectedDevices] = useState([])
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)
  const [inviteEmail, setInviteEmail] = useState("")
  const [inviteStatus, setInviteStatus] = useState("")
  const [isSelectMode, setIsSelectMode] = useState(false)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

  // Pending Invites State
  const [pendingInvites, setPendingInvites] = useState([])
  const [isPendingInvitesModalOpen, setIsPendingInvitesModalOpen] = useState(false)
  const [acceptingInviteId, setAcceptingInviteId] = useState(null)

  useEffect(() => {
    const getTokenDetails = async () => {
      try {
        const token = {
          token: localStorage.getItem("token"),
        }
        console.log(token)
        const response = await axios.post(
          `${baseUrl}/api/v1/dashboard/getTokenDetails`,
          token
        )

        console.log(response)
        if (response.data.error) {
          localStorage.clear()
          navigate("/admin-login")
        } else {
          setUserRole(response.data.role)
          setUserId(response.data.userId)

          if (userRole === "company-admin") {
            const userData = await axios.post(
              `${baseUrl}/api/v1/companyAuth/getCompanyIdFromUserId`,
              { userId: userId }
            )
            console.log(userData)
            if (userData.data.connected_company) {
              setCompanyId(userData.data.connected_company)
            }
          }

          setUserId(response.data.userId)
          console.log("The role is" + userRole)
        }
      } catch (err) {
        console.log(err)
      }
    }
    getTokenDetails()
  }, [userRole == ""])

  useEffect(() => {
    const fetchPendingInvites = async () => {
      if (userRole === "SUB_USER" || userRole === "company-subuser") {
        try {
          const token = localStorage.getItem("token")
          const response = await axios.get(`${baseUrl}/api/v1/companyAuth/pending-invites`, {
            headers: { Authorization: `Bearer ${token}` }
          })
          if (response.data.invites && response.data.invites.length > 0) {
            setPendingInvites(response.data.invites)
            setIsPendingInvitesModalOpen(true)
          }
        } catch (err) {
          console.error("Failed to fetch pending invites", err)
        }
      }
    }
    fetchPendingInvites()
  }, [userRole, baseUrl])

  useEffect(() => {
    const fetchData = async () => {
      const segment = window.location.href.split("/")
      const CompanyId = segment[segment.length - 1]
      setCompanyID(CompanyId)
      try {
        const token = localStorage.getItem("token")
        const response = await axios.get(
          `${baseUrl}/api/v1/devices/devices-list/${CompanyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setDevices(response.data.companydevices)
      } catch (error) {
        console.log("Failed to retrieve devices data", error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [companyID])

  useEffect(() => {
    const companyDetails = async () => {
      const segment = window.location.href.split("/")
      const Companyname = segment[segment.length - 1]
      console.log(Companyname)
      try {
        const response = await axios.get(
          `${baseUrl}/api/v1/companies/company-details/${Companyname}`
        )
        setCompany(response.data.Selectcompany)
        console.log(response.data.Selectcompany.name)
      } catch (error) {
        console.log("Failed to retrieve devices data", error)
      }
    }
    companyDetails()
  }, [])

  const handleInputChange = event => {
    const newSearchTerm = event.target.value
    setSearchTerm(newSearchTerm)
    performSearch(newSearchTerm)
  }

  const performSearch = term => {
    const results = devices.filter(device =>
      device.device_name.toLowerCase().includes(term.toLowerCase())
    )
    setSearchResults(results)
    console.log(searchResults)
  }

  const handleSendInvite = async () => {
    if (!inviteEmail || selectedDevices.length === 0) return;

    try {
      setInviteStatus("Sending invite...");
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${baseUrl}/api/v1/companyAuth/invite-subuser`,
        {
          email: inviteEmail,
          assigned_devices: selectedDevices,
          connected_company: companyID
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setInviteStatus("Invite sent successfully!");
      setInviteEmail("");
      setTimeout(() => {
        setIsInviteModalOpen(false);
        setInviteStatus(null);
        setSelectedDevices([]); // Clear selection
      }, 2000);
    } catch (err) {
      console.error(err);
      setInviteStatus("Failed to send invite. Please try again.");
    }
  };

  const handleAcceptInvite = async (inviteId) => {
    try {
      setAcceptingInviteId(inviteId)
      const token = localStorage.getItem("token")
      await axios.post(`${baseUrl}/api/v1/companyAuth/accept-invite/${inviteId}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      })
      const remainingInvites = pendingInvites.filter(inv => inv._id !== inviteId)
      setPendingInvites(remainingInvites)
      if (remainingInvites.length === 0) {
        setIsPendingInvitesModalOpen(false)
      }
      window.location.reload()
    } catch (err) {
      console.error("Failed to accept invite", err)
      setAcceptingInviteId(null)
    }
  }

  const filteredColumns = searchTerm.length > 0 ? searchResults : devices

  const toggleDeviceSelection = (deviceId) => {
    setSelectedDevices((prevSelected) => {
      if (prevSelected.includes(deviceId)) {
        return prevSelected.filter((id) => id !== deviceId)
      } else {
        return [...prevSelected, deviceId]
      }
    })
  }

  const toggleSelectAll = () => {
    if (selectedDevices.length === filteredColumns.length && filteredColumns.length > 0) {
      setSelectedDevices([])
    } else {
      setSelectedDevices(filteredColumns.map((device) => device._id))
    }
  }

  return (
    <div className="page-content">

      <Container fluid={true}>
        <Breadcrumbs
          title="companies"
          breadcrumbItem="Companies Control Devices"
        ></Breadcrumbs>
        {loading ? (
          <Loader message="Loading company devices..." />
        ) : (
          <>
            <div>
              <Row className="mb-4">
                <Col xl={12}>
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <div className="d-flex align-items-center">
                      <h5 className="me-3 mb-0">{company.name}</h5>
                      {userRole !== 'SUB_USER' && userRole !== 'company-subuser' && (
                        <>
                          <Link to={`/subusers/${companyID}`} className="btn btn-outline-info btn-sm me-2">
                            Manage Sub-Users
                          </Link>
                          <Button color="link" className="p-0 text-info" onClick={() => setIsInfoModalOpen(true)} title="Information">
                            <i className="mdi mdi-information-outline font-size-24"></i>
                          </Button>
                        </>
                      )}
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-2">
                      {userRole !== 'SUB_USER' && userRole !== 'company-subuser' && (
                        <>
                          {!isSelectMode ? (
                            <Button color="secondary" onClick={() => setIsSelectMode(true)} className="btn-sm">
                              Select Devices
                            </Button>
                          ) : (
                            <>
                              <Button color="secondary" onClick={() => { setIsSelectMode(false); setSelectedDevices([]); }} className="btn-sm">
                                Cancel Selection
                              </Button>
                              <Button color="secondary" onClick={toggleSelectAll} className="btn-sm">
                                {selectedDevices.length === filteredColumns.length && filteredColumns.length > 0 ? "Deselect All" : "Select All"}
                              </Button>
                              <Button
                                color="primary"
                                className="btn-sm"
                                disabled={selectedDevices.length === 0}
                                onClick={() => setIsInviteModalOpen(true)}
                              >
                                Assign to new user ({selectedDevices.length})
                              </Button>
                            </>
                          )}
                        </>
                      )}
                      <div className="search-box">
                        <div className="position-relative">
                          <input
                            type="text"
                            value={searchTerm}
                            onChange={handleInputChange}
                            className="form-control bg-light border-light rounded"
                            placeholder="Search..."
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Col xl="12">
              <Row>
                {filteredColumns.length > 0 ? (
                  filteredColumns.map(device => (
                    <Col key={device._id} sm="6">
                      {isSelectMode && (
                        <div className="position-absolute" style={{ zIndex: 10, right: 30, top: 15, pointerEvents: 'none' }}>
                          <Input
                            type="checkbox"
                            checked={selectedDevices.includes(device._id)}
                            readOnly
                            style={{ transform: "scale(1.5)", cursor: "pointer" }}
                          />
                        </div>
                      )}
                      <Link
                        to={isSelectMode ? "#" : `/devicesdashboard/${companyID}/${device._id}`}
                        onClick={(e) => {
                          if (isSelectMode) {
                            e.preventDefault();
                            toggleDeviceSelection(device._id);
                          }
                        }}
                        className="text-black"
                      >
                        <Card className="mini-stats-wid position-relative">
                          <CardBody>
                            <Row>
                              <Col>
                                <div className="d-flex">
                                  <h5 style={{ fontWeight: "bolder" }}>Name:</h5>
                                  &nbsp;
                                  <span style={{ fontSize: "15px" }}>
                                    {" "}
                                    {device.device_name}
                                  </span>
                                </div>
                                <div className="d-flex">
                                  <h5 style={{ fontWeight: "bolder" }}>
                                    Location:
                                  </h5>
                                  &nbsp;
                                  <span style={{ fontSize: "15px" }}>
                                    {" "}
                                    {device.device_location}
                                  </span>
                                </div>
                                <div className="d-flex">
                                  <h5 style={{ fontWeight: "bolder" }}>Type:</h5>
                                  &nbsp;
                                  <span style={{ fontSize: "15px" }}>
                                    {device.device_type}
                                  </span>
                                </div>
                              </Col>
                              <Col className="text-right-end">
                                {(() => {
                                  const { text, colorClass } = stateLabel(device)
                                  return (
                                    <h5
                                      className="font-weight-bold"
                                      style={{ fontWeight: "bolder" }}
                                    >
                                      Status:&nbsp;
                                      <span className={colorClass}>{text}</span>
                                    </h5>
                                  )
                                })()}
                                <div className="d-flex">
                                  <h5 style={{ fontWeight: "bolder" }}>
                                    {" "}
                                    BR1 / BR2:{" "}
                                  </h5>
                                  &nbsp;
                                  <span style={{ fontSize: "15px" }}>
                                    {" "}
                                    {device.BR1_STATUS || "N/A"} / {device.BR2_STATUS || "N/A"}
                                  </span>
                                </div>

                                <div className="d-flex">
                                  <h5 style={{ fontWeight: "bolder" }}>
                                    Serial Id:
                                  </h5>
                                  &nbsp;
                                  <span style={{ fontSize: "15px" }}>
                                    {" "}
                                    {device.device_serialId}
                                  </span>
                                </div>

                                {/* <h5>Created Date:{device.device_createdDate}</h5> */}
                                {/* <div className="d-flex">
                              <h5 style={{ fontWeight: "bolder" }}>Temp:</h5>
                              &nbsp;
                              <span style={{ fontSize: "15px" }}> 23 </span>
                              &nbsp;|&nbsp;
                              <h5 style={{ fontWeight: "bolder" }}> Hum:</h5>
                              &nbsp;
                              <span style={{ fontSize: "15px" }}> 24 </span>
                            </div> */}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  ))
                ) : (
                  <>
                    <div className="d-flex justify-content-center">
                      <img
                        src={notDeviceFound}
                        className="w-50"
                        alt="No Device Found"
                      />
                    </div>
                    <h2 className="text-center">No Devices Found.</h2>
                  </>
                )}
              </Row>
            </Col>
          </>
        )}
      </Container>

      {/* Invite Modal */}
      <Modal isOpen={isInviteModalOpen} toggle={() => setIsInviteModalOpen(false)}>
        <ModalHeader toggle={() => setIsInviteModalOpen(false)}>Assign Devices to New User</ModalHeader>
        <ModalBody>
          <Form>
            <div className="mb-3">
              <Label htmlFor="inviteEmail">User Email Address</Label>
              <Input
                type="email"
                id="inviteEmail"
                placeholder="Enter email to send invite"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
            </div>
            <p>You have selected <strong>{selectedDevices.length}</strong> device(s) to assign to this user.</p>
            {inviteStatus && (
              <p className={inviteStatus.includes("success") ? "text-success" : "text-danger"}>
                {inviteStatus}
              </p>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsInviteModalOpen(false)}>Cancel</Button>
          <Button color="primary" onClick={handleSendInvite} disabled={!inviteEmail || selectedDevices.length === 0}>
            Send Invite
          </Button>
        </ModalFooter>
      </Modal>

      {/* Info Modal */}
      <Modal isOpen={isInfoModalOpen} toggle={() => setIsInfoModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setIsInfoModalOpen(false)}>Sub-User Management Guide</ModalHeader>
        <ModalBody>
          <h5>How to Assign Devices to a New User</h5>
          <ol>
            <li>Click the <strong>Select Devices</strong> button.</li>
            <li>Select checkboxes for the devices you want to assign.</li>
            <li>Click <strong>Assign to new user</strong> and enter the user's email address.</li>
            <li>An invitation email will be sent to the user.</li>
          </ol>
          <hr />
          <h5>Important Links</h5>
          <p>Share these links with your users:</p>
          <ul>
            <li><strong>Login Link (Existing Users):</strong> <br />
              <code>{window.location.origin}/company-login</code>
            </li>
            <li><strong>Registration Link (New Users via Invite):</strong> <br />
              Users must click the link sent to their email to accept devices and complete registration.
            </li>
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsInfoModalOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      {/* Pending Invites Modal */}
      <Modal isOpen={isPendingInvitesModalOpen} backdrop="static" keyboard={false}>
        <ModalHeader>Pending Device Assignments</ModalHeader>
        <ModalBody>
          <p>You have pending invitations to manage devices.</p>
          {pendingInvites.map((invite) => (
            <div key={invite._id} className="border p-3 mb-3 rounded d-flex justify-content-between align-items-center">
              <div>
                <strong>Company:</strong> {invite.connected_company?.company_name || 'Assigned Company'}<br />
                <strong>New Devices:</strong> {invite.assigned_devices?.length || 0}
              </div>
              <Button
                color="success"
                size="sm"
                onClick={() => handleAcceptInvite(invite._id)}
                disabled={acceptingInviteId === invite._id}
              >
                {acceptingInviteId === invite._id ? "Accepting..." : "Accept"}
              </Button>
            </div>
          ))}
        </ModalBody>
      </Modal>

    </div>
  )
}
